























import Vue from "vue";
import iwAccordion from "@/encoding/components/Accordion.vue";
import iwInputCheckbox from "@/encoding/components/buildingBlocks/InputCheckbox.vue";
import iwPriceOfBusiness from "./PriceOfBusiness.vue";
import { mapActions } from "vuex";

export default Vue.extend({
    components: {
        iwAccordion: iwAccordion,
        iwInputCheckbox: iwInputCheckbox,
        iwPriceOfBusiness: iwPriceOfBusiness,
    },
    data: function() {
        return {
            pathInStore: "property.specificities.shop.hasGoodwill",
            pathInStoreGoodWillPrice: "property.specificities.shop.goodwillPrice",
        };
    },
    computed: {
        isDisplayed: function(): boolean {
            return ["COMMERCIAL"].indexOf(this.getPropertyType()) !== - 1;
        },

        showGoodWill: function(): boolean {
            return (["COMMERCIAL"].indexOf(this.getPropertyType()) !== - 1
                && this.$store.getters["FormModule/getValue"]("transaction.type") === "FOR_SALE");
        },

        priceOfBusiness: function(): number | null {
            return this.$store.getters["FormModule/getValue"](this.pathInStoreGoodWillPrice);
        },

        errorMessage: function(): string|null {
            return this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStore) || this.$store.getters["FormModule/getErrorObjectByPath"](this.pathInStoreGoodWillPrice);
        },

        hasGoodwill: {
            get: function(): boolean {
                return !!this.$store.getters["FormModule/getValue"](this.pathInStore);
            },

            set: function(value: boolean) {
                this.$store.dispatch("FormModule/addValue", {
                    path: this.pathInStore,
                    value: value,
                });

                // Remove “price of business” when unchecked.
                if (!value) {
                    this.deleteValuePath(this.pathInStoreGoodWillPrice);
                }
            },
        },
    },
    created: function() {
        if (this.isDisplayed && this.hasGoodwill == null) {
            this.hasGoodwill = false;
        }

        if (!this.showGoodWill) {
            this.deleteValuePath(this.pathInStoreGoodWillPrice);
        }
    },

    methods: {
        ...mapActions({
            deleteValuePath: "FormModule/deleteValuePath",
        }),
    },
});
